import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {
  Row,
  Col,
  Icon,
  Grid,
  Table,
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
  PanelContainer,
  Radio,
  Checkbox,
  FormGroup,
  InputGroup,
  ControlLabel,
  Button,
  Form,
  FormControl,
  Well,
} from '@sketchpixy/rubix';
import _ from 'lodash';

import {
  getClinicianList,
  getPatientListForMapping,
  getClinicianPatientMapping,
  mapPatientToClinicians,
  getServiceRegion,
} from '../../../api/api';
import RoleType from '../../RoleGroup/Roles/RoleType';
import {checkRole} from '../../../util/RoleChecker';
import {routeUrl} from '../../routeUrl';

const CHECKED_BUTTON_ICON = 'icon-fontello-check-3';
const UNCHECKED_BUTTON_ICON = 'icon-fontello-check-empty-1';
const REGION_ALL = null;

export default class PatientDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clinicians: [],
      patientId: null,
      roleRegion: REGION_ALL,
      serviceRegions: [],
      search: {
          country: REGION_ALL,
          query: '',
          gender: ''
      }
    };
  }

  componentWillReceiveProps() {
      if(this.props.patientId === null) return;
      this.initClinicianDetail();
  }

  componentDidMount() {
      if(this.props.patientId === null) return;
      this.initClinicianDetail();
  }

  initClinicianDetail()
  {
      const patientId = parseInt(this.props.patientId);

      this.setState({
          patientId
      },() => {
          this.doInitClinicianDetail();
      });
  }

  doInitClinicianDetail ()
  {
      let self = this;

        Messenger.options = {
          theme: 'flat',
        };

        const requiredRoles = [
          RoleType.CLINICIAN_PATIENT_MAPPING,
          RoleType.CLINICIAN_PATIENT_MAPPING_READ_ONLY,
        ];

        checkRole(requiredRoles, this.props.router);

        let roles = JSON.parse(localStorage.getItem('roles'));
        let roleRegion = null;

        requiredRoles.forEach(requiredRoleType => {
          roles.forEach(role => {
            if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
              roleRegion = role.region;
            }
          });
        });

        this.setState({
            roleRegion,
            search: {country: (roleRegion === 'ALL' ? '' : roleRegion)}
          });

        getServiceRegion((err, result) => {
          if (err) {
            this.props.router.push(routeUrl.login);
          } else {
            this.setState({
              serviceRegions: result.list,
            });
          }
        });

        let datatables =  this.initClincianTable();
        let selectedCliniciansTables =  this.initSelectedClinicianTable();

        getClinicianPatientMapping(self.state.patientId, (err, res) => {
            selectedCliniciansTables.clear();
            selectedCliniciansTables.rows.add(res.clinicians);
            selectedCliniciansTables.draw();

            this.setState({
                datatables,
                selectedCliniciansTables
            },() => {
                self.doSearch();
            });
         });
  }
  initClincianTable()
  {
      let self = this;
      let datatableDom = $(ReactDOM.findDOMNode(this.refs.cliniciansTables));
      if ($.fn.DataTable.isDataTable(datatableDom ) ) {
          return this.state.datatables;
      }

      let datatables = datatableDom.addClass('nowrap')
          .DataTable({
            language: { infoFiltered: "" },
            processing: true,
            serverSide: true,
            responsive: true,
            searchDelay: 2000,
            searching: false,
            ajax : function (data, callback, settings) {
               let search = self.state.search;
               let param = _.merge({}, data, search)
               getClinicianList(param, (err, res) => {
                 self.setState({ clinicians: res.clinicians });
                 callback(res.clinicians);
               });
            },
            columns: [
                 {
                    name: 'clinicianDto.clinicianFirstName',
                    data: 'clinicianDto.clinicianFirstName',
                    defaultContent : "",
                     render: function ( data, type, row ) {
                         return data.length > 20 ? data.substr( 0, 20 ) +'…' : data;
                     }
                  },
                  {
                    name: 'clinicianDto.clinicianLastName',
                    data: 'clinicianDto.clinicianLastName',
                    defaultContent : "",
                      render: function ( data, type, row ) {
                          return data.length > 20 ? data.substr( 0, 20 ) +'…' : data;
                      }
                  },
                  {
                    name: 'userDto.userEmail',
                    data: 'userDto.userEmail',
                    defaultContent : ""
                  },
                  {
                      name: 'clinicianDto.clinicianGender',
                      data: 'clinicianDto.clinicianGender',
                      defaultContent : "",
                      render: function ( data, type, row ) {
                          let str = data.toLowerCase()
                          return str.charAt(0).toUpperCase() + str.slice(1);
                      }
                  },
                  {
                	  name: 'clinicianDto.countryDto.countryAlpha3Code',
                      data: 'clinicianDto.countryDto.countryAlpha3Code',
                      defaultContent : ""
                  },
                {
                  name: 'actions',
                  data: 'clinicianId',
                  orderable: false,
                  defaultContent : "",
                  render: function (clinicianId, type, row) {
                    let buttons = '';

                    buttons +="<Button class='btn btn-info'  data-id='"+clinicianId+"' data-action='SELECT'>Select</Button>"; //수정

                    return buttons;
                  }
                },
            ],
            rowId: 'clinicianId',
            select: true
        });

        datatableDom.find('tbody').on('click', 'button',  function (event) {
          //선택된 환자
          let clinicianId = $(event.target).data("id");
          let clinician = self.state.clinicians.data.find(function(clinician) {
            return clinician.clinicianId === clinicianId;
          });

          //이미 선택된 환자 인지 검사
          let selectedCliniciansTables = self.state.selectedCliniciansTables;

          let data = selectedCliniciansTables.rows().data();

          for(let idx = 0; idx < data.length; idx++)
          {
            if(data[idx].clinicianId === clinicianId)
            {
              return Messenger().post({
                      type: 'error',
                      message: `Already selected user!`,
                      showCloseButton: true,
              });
            }
          }

          let action = $(event.target).data("action");
          switch(action)
          {
              case 'SELECT':
                selectedCliniciansTables.row.add(clinician).draw(false);
              break;
          }
        });

        return datatables;
  }

  initSelectedClinicianTable()
  {
      let self = this;
      let datatableDom = $(ReactDOM.findDOMNode(this.refs.selectedCliniciansTables));
      if ($.fn.DataTable.isDataTable(datatableDom ) ) {
          return this.state.selectedCliniciansTables;
      }
      let datatables = datatableDom.addClass('nowrap').DataTable({
        language: { infoFiltered: "" },
        processing: true,
        serverSide: false,
        responsive: true,
        searchDelay: 2000,
        searching: false,
        columns: [
            {
              name: 'clinicianDto.clinicianFirstName',
              data: 'clinicianDto.clinicianFirstName',
              defaultContent : ""
            },
            {
              name: 'clinicianDto.clinicianLastName',
              data: 'clinicianDto.clinicianLastName',
              defaultContent : ""
            },
            {
              name: 'userDto.userEmail',
              data: 'userDto.userEmail',
              defaultContent : ""
            },
            {
                name: 'clinicianDto.clinicianGender',
                data: 'clinicianDto.clinicianGender',
                defaultContent : "",
                render: function ( data, type, row ) {
                    let str = data.toLowerCase()
                    return str.charAt(0).toUpperCase() + str.slice(1);
                }
            },
            {
                name: 'clinicianDto.countryDto.countryAlpha3Code',
                data: 'clinicianDto.countryDto.countryAlpha3Code',
                defaultContent : ""
            },
            {
              name: 'actions',
              data: 'clinicianId',
              orderable: false,
              defaultContent : "",
              render: function (clinicianId, type, row) {
                let buttons = '';

                buttons +="<Button class='btn btn-info'  data-id='"+clinicianId+"' data-action='DELETE'>Remove</Button>"; //수정

                return buttons;
              }
            },
        ],
        rowId: 'clinicianId',
        select: true
    });


        datatableDom.find('tbody').on('click', 'button',  function (event) {
          let clinicianId = $(event.target).data("id");
          let action = $(event.target).data("action");

          switch(action)
          {
              case 'DELETE':
                  let selectedCliniciansTables = self.state.selectedCliniciansTables;
                  selectedCliniciansTables.rows( function ( idx, data, node ) {
                      return data.clinicianId === clinicianId;
                  }).remove().draw(false);
              break;
          }
        });

        return datatables;
  }

  doSearch = () => {
      this.state.datatables.ajax.reload();
  }

  saveButtonClickHandler = () => {
    let self = this;
    const patientId = this.state.patientId;
    if (!patientId) {
      return Messenger().post({
        type: 'error',
        message: `Select clinician at least 1.`,
        showCloseButton: true,
      });
    }

    let selectedCliniciansTables = this.state.selectedCliniciansTables;
    let data = selectedCliniciansTables.rows().data();
    let clinicianIds = [];
    for(let idx = 0; idx < data.length; idx++)
    {
    	clinicianIds.push(data[idx].clinicianId);
    }

    if(clinicianIds.length > 1)
    {
        vex.dialog.alert('Select only one clinician.');
        return
    }

    mapPatientToClinicians(patientId, clinicianIds, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
          getClinicianPatientMapping(self.state.patientId, (err, res) => {
              selectedCliniciansTables.clear();
              selectedCliniciansTables.rows.add(res.clinicians);
              selectedCliniciansTables.draw();
          });

          Messenger().post({
             type: 'success',
             message: 'Saved Successfully.',
             showCloseButton: true,
          });
      }
    });
  };

  patientCountryChangeHandler = (event) => {
    let country = event.target.value === 'ALL' ? '' : event.target.value;
    this.setState({
       search: {...this.state.search, country: country},
    });
  };

  queryChangeHandler = (event) => {
    let query = event.target.value;
    this.setState({
      search: {...this.state.search, query: query},
    });
  };

  genderChangeHandler = (event) => {
    let gender = event.target.value === 'ALL' ? '' : event.target.value;
    this.setState({
      search: {...this.state.search, gender: gender},
    });
  };

  render() {
    return (
          <Row>
          <Col sm={6}>
          <PanelContainer controls={false}>
            <Panel>
              <PanelHeader style={{padding: 0}}>
                <Grid>
                  <Row>
                    <Col xs={12}>
                      <h3>Clinician list</h3>
                      <Well>
                      <Form inline>
                        <FormGroup controlId="patientCountrySelect">
                          <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Country</ControlLabel>
                          <FormControl
                              onChange={this.patientCountryChangeHandler}
                              componentClass="select"
                              style={{width: '120px'}}
                          >
                            <option value={null}>ALL</option>
                            {
                              this.state.serviceRegions.map(serviceRegion => (
                                  <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                    {serviceRegion.countryAlpha3Code}
                                  </option>
                              ))
                            }
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Gender</ControlLabel>
                          <FormControl
                            onChange={this.genderChangeHandler}
                            componentClass="select"
                            style={{width: '120px'}}
                          >
                          <option value={null}>ALL</option>
                          <option value='MALE'>Male</option>
                          <option value='FEMALE'>Female</option>
                          <option value='OTHER'>Other</option>
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Search Word</ControlLabel>
                            <FormControl type='text' placeholder='Search Word' onChange={this.queryChangeHandler}/>
                        </FormGroup>
                        <FormGroup className="pull-right">
                            <InputGroup.Button>
                                <Button onClick={this.doSearch}>Search</Button>
                            </InputGroup.Button>
                        </FormGroup>
                      </Form>
                    </Well>
                    </Col>
                  </Row>
                </Grid>
              </PanelHeader>
              <PanelBody style={{padding: 0}}>
                  <Table ref="cliniciansTables" className='display' cellSpacing='0' width='100%'>
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Gender</th>
                      <th>Country</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                </Table>
              </PanelBody>
            </Panel>
          </PanelContainer>
        </Col>
            <Col sm={6}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>Selected Clinician</h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 0}}>
                      <Table ref="selectedCliniciansTables" className='display' cellSpacing='0' width='100%'>
                      <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Gender</th>
                            <th>Country</th>
                            <th>Actions</th>
                        </tr>
                      </thead>
                    </Table>
                  </PanelBody>
                  <PanelFooter>
                      <Row>
                          <Col xs={12}>
                            <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                              <Button bsStyle='brownishgray' onClick={this.props.showListHandler} style={{marginRight: '8px'}}>List</Button>
                              <Button bsStyle='brownishgray' onClick={this.saveButtonClickHandler} style={{marginRight: '8px'}}>Save</Button>
                            </div>
                          </Col>
                      </Row>
                  </PanelFooter>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/cp-mapping/components/PatientDetail.js